export function setupPager() {
    document.addEventListener('change', function (e) {
        var el = e.target.closest('.hawk-pageSelect');

        if (!el) {
            return;
        }

        window.location.href = el.value;
    })

    document.addEventListener('change', function (e) {
        var el = e.target.closest('.hawksortby');

        if (!el) {
            return;
        }

        window.location.href = el.value;
    })

    document.addEventListener('change', function (e) {
        var el = e.target.closest('.hawkmpp');

        if (!el) {
            return;
        }

        var pageSize = el.value;

        if (phe.config.cookies.allowFunctionalCookies) {
            window.SetCookie('pagesize', pageSize, 7);
        }

        window.location.href = el.options[el.selectedIndex].getAttribute('data-href');
    })
}
